export const defaultDamageFromDirectionSVGPaths = [
  {
    side: "front",
    d: "M151.5,27.5c12.6,0.13 23.49,-0.5 38,0.66c9.61,0.77 17.66,1.89 23.5,2.84c-2.12,21 -4.157,42.167 -6.11,63.5c-1.9,20.82 -3.697,41.487 -5.39,62c-28.22,-5.94 -56.93,-5.75 -86.06,0l-17.94,-123c5.012,-1.716 10.16,-3.004 15.39,-3.85c12.814,-1.5 25.708,-2.218 38.61,-2.15Z",
  },
  {
    side: "front_right",
    d: "M201.5,156.5c10.89,2.86 22.63,6.46 35,11c10.47,3.84 20.15,7.91 29,12l0,-83.34c-1.028,-8.492 -3.355,-16.775 -6.9,-24.56c-2.534,-5.318 -5.582,-10.375 -9.1,-15.1c-12.12,-15.75 -32.84,-24.07 -36.5,-25.5c-3.827,41.833 -7.66,83.667 -11.5,125.5Z",
  },
  {
    side: "right",
    d: "M265.5,179.59c-20.463,-9.924 -41.915,-17.663 -64,-23.09c1.333,43.48 2,88.147 2,134c0,45.333 -0.667,89.533 -2,132.6c21.777,1.494 43.28,5.724 64,12.59l0,-256.1Z",
  },
  {
    side: "roof",
    d: "M203.302,255.417c-35.794,-3.56 -54.71,-2.909 -89.998,-0.313c-1.029,47.067 2.033,129.509 2.998,169.085c21.297,1.853 45.77,2.034 85.276,-1.171c1.477,-56.758 2.016,-112.591 1.724,-167.601Z",
  },
  {
    side: "rear_right",
    d: "M265.5,436.03c-20.647,-7.195 -42.179,-11.545 -64,-12.93c-0.333,19.873 -0.667,39.743 -1,59.61c-0.333,19.867 -0.667,39.797 -1,59.79c32.794,-1.426 60.405,-25.715 66,-58.06l0,-48.41Z",
  },
  {
    side: "rear",
    d: "M116.5,424.5c13.08,0.8 25.12,1.2 40,1c16,-0.22 31.07,-1.1 45,-2.4c-0.667,39.8 -1.333,79.6 -2,119.4l-82,0c-1,-39.33 0,-78.67 -1,-118Z",
  },
  {
    side: "rear_left",
    d: "M116.5,424.5l1,118c-13.421,-1.016 -26.269,-5.877 -37,-14c-21.23,-16.25 -25.6,-39.5 -26.49,-45l0,-59c20.744,-2.668 41.746,-2.668 62.49,0Z",
  },
  {
    side: "front_left",
    d: "M97.5,33.5l17.94,123c-21.976,3.899 -43.08,11.688 -62.32,23l0,-87.53c4.857,-25.328 21.291,-46.98 44.38,-58.47Z",
  },
  {
    side: "left",
    d: "M115.44,156.5c-21.976,3.899 -43.08,11.688 -62.32,23c0.287,81.673 0.583,163.34 0.89,245c20.745,-2.667 41.745,-2.667 62.49,0c-1.72,-42 -2.72,-85.333 -3,-130c-0.24,-47.487 0.407,-93.487 1.94,-138Z",
  },
];
